import moment from 'moment';
import type { IBatchStore } from './batch-store-types';
import type { IWeighedDataToBatch } from '../../../types/batch/DataToBatch';
import type { IBatchData } from '../../containers/Batch/IBatchData';
import type { IBin } from '../../../types/device/DeviceModels';

export const binScaleDataMixin = {

  /**
   * Get bins for batch
   */
  getBins(this: IBatchStore, data: IWeighedDataToBatch): {
    primaryBin: IBin,
    secondaryBin: IBin | null,
  } {
    const { bin, material } = data;
    const { devicesStore } = this;
    let primaryBin = devicesStore.getPrimaryBin(material);
    let secondaryBin = devicesStore.getSecondaryBin(material);

    // If a specific bin is provided in data, use it
    // This handles both regular bins with binPercent and substitute bins
    if (bin) {
      // Check if this is a substitute material or has explicit binPercent
      const useExplicitBin = data.isSubstituted ||
                             (data.binPercent && typeof data.binPercent[bin.id] === 'number' && data.binPercent[bin.id] >= 0);

      if (useExplicitBin) {
        primaryBin = devicesStore.getDeviceById(bin.id);
        secondaryBin = null;
      }
    }

    return {
      primaryBin,
      secondaryBin,
    };
  },

  /**
   * Check if belt is on
   */
  isBeltOn(this: IBatchStore, beltId: number) {
    const belt = this.devicesStore.getDeviceById(Number(beltId));

    if (beltId && belt) {
      if (belt.offPNo) {
        const { active, startTime } = this.getDeviceStatus(belt.id);
        let diff = 0;
        if (startTime) {
          const endTime = moment();
          diff = Math.round(endTime.diff(startTime) / 1000);
        }
        return this.isOutputOn(belt.onPNo) || (!!active && diff > 0);
      }

      return this.isOutputOn(belt.onPNo);
    }

    return false;
  },

  /**
   * Get first binId for the scale
   */
  getFirstBinIdForTheScale(this: IBatchStore, initialData: IBatchData, scaleId: number) {
    return initialData?.scales?.[scaleId]?.[0]?.bin ? initialData.scales[scaleId][0].bin.id : 0;
  },

  /**
   * Get first material code for the scale
   */
  getFirstMaterialForTheScale(this: IBatchStore, initialData: IBatchData, scaleId: number) {
    return initialData.scales?.[scaleId]?.[0]?.material ? initialData.scales[scaleId][0].material.code : '';
  },

  /**
   * Get last material code for the scale
   */
  getLastMaterialForTheScale(this: IBatchStore, initialData: IBatchData, scaleId: number) {
    const last = initialData.scales[scaleId].length - 1;
    return initialData.scales?.[scaleId]?.[last]?.material ? initialData.scales[scaleId][last].material.code : '';
  },

};
